import React, { useState } from "react";
import { Row, Col, Image } from "antd";

const DynamicGalleryGrid = ({ selectedTour }) => {
  const [visible, setVisible] = useState(false);

  // Flatten all images from selected tour
  const allImages = selectedTour?.Gallery?.flatMap(tour => tour.images) || [];

  // Number of images to show in grid before overlay
  const visibleCount = 3;

  const remainingCount = allImages.length - visibleCount;

  return (
    <>
      {/* Hidden Preview Group for all images */}
      <div style={{ display: "none" }}>
        <Image.PreviewGroup
          preview={{ visible, onVisibleChange: (vis) => setVisible(vis) }}
        >
          {allImages.map((image) => (
            <Image
              src={`${process.env.REACT_APP_API_URL}${image.url}`}
              key={image.id}
              alt={image.name || "tour image"}
            />
          ))}
        </Image.PreviewGroup>
      </div>

      {/* Grid showing first 4 images + overlay for remaining */}
      <Row gutter={[12, 12]}>
        {allImages.slice(0, visibleCount).map((image, index) => (
          <Col xs={12} key={image.id}>
            <Image
              width="100%"
              src={`${process.env.REACT_APP_API_URL}${image.url}`}
              alt={image.name || `Photo ${index}`}
              className="w-full !h-[140px] max-h-[140px] rounded-[10px] object-cover"
            />
          </Col>
        ))}

        {remainingCount > 0 && (
          <Col xs={12}>
            <div
              onClick={() => setVisible(true)}
              style={{
                position: "relative",
                height: "140px",
                borderRadius: "12px",
                overflow: "hidden",
                backgroundImage: `url(${process.env.REACT_APP_API_URL}${allImages[visibleCount].url})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                cursor: "pointer",
              }}
            >
              <div className="absolute inset-0 bg-[rgba(0,0,0,0.6)] text-white flex items-center justify-center flex-col text-[16px] font-medium">
                <span>+{remainingCount}</span>
                <span>More Photos</span>
              </div>
            </div>
          </Col>
        )}
      </Row>
    </>
  );
};

export default DynamicGalleryGrid;
